import { DOMHelper } from '../Helpers/DOMHelper.js';

export class TradeIn {

	constructor(pmdrs){
		this.pmdrs = pmdrs;
		this.parentId = pmdrs.config.elementId;
		this.classAtt = 'trade-in';
	}

	init(){
		this.eventHandlers();
	}

	getHtml(){
		return `<div class="trade-in">
	<div class="font-24">Estimated value of your car</div>
	<form>
		<input type="number" name="tradeInEstimate">
		<button>Set</button>
	</form>
</div>	`;
	}

	setSubmitCallback(submitCallback){
		this.submitCallback = submitCallback;
	}

	eventHandlers(){
		let thisTradeIn = this;
		DOMHelper.addHandler(this.getSelector('form'), 'submit',  (event)=> {
			event.preventDefault();			
			
			//FORM DATA AS JSON
			const data = new FormData(event.target);
			const values = Object.fromEntries(data.entries());
			thisTradeIn.pmdrs.tradeInModal.hide();
			
			thisTradeIn.submitCallback(values);
			return false;
		});
	}

	getSelector(selector){
		return this.pmdrs.getSelector("." + this.classAtt + " " + selector);
	}
}